/* PartnersStrip — "Aligned with the certifications employers ask for".
 *
 * Honest framing: ZHELTA Academy preps students for these vendor exams,
 * we don't claim official partnership beyond the published curriculum.
 * Wordmarks rendered as styled text (no licensed logos) — clean, neutral.
 * Each chip clicks through to the matching program detail page so search
 * traffic landing here on a wordmark search has a relevant destination. */
import React from 'react';
import { Link } from 'react-router-dom';

const PARTNERS = [
  { label: 'CompTIA',      href: '/academy/programs/it-certification-programs',     mono: false, sub: 'A+ · Network+ · Security+' },
  { label: 'aws',          href: '/academy/programs/it-certification-programs',     mono: true,  sub: 'Cloud Practitioner' },
  { label: 'Microsoft',    href: '/academy/programs/it-certification-programs',     mono: false, sub: 'Azure Fundamentals' },
  { label: 'cisco',        href: '/academy/programs/it-certification-programs',     mono: true,  sub: 'CCNA-aligned' },
  { label: 'Google Cloud', href: '/academy/programs/it-certification-programs',     mono: false, sub: 'Cloud Digital Leader' },
  { label: 'GES',          href: '/academy/programs/learning-boost-program',        mono: false, sub: 'Curriculum-aligned' },
];

export default function PartnersStrip() {
  return (
    <section
      data-testid="academy-partners-strip"
      className="relative bg-white border-b border-[#F0EDE5] py-10 md:py-12"
    >
      <div className="zh-container">
        <div className="text-center mb-8">
          <span className="text-[10.5px] font-bold uppercase tracking-[0.28em] text-[#a8871a]">
            Aligned with the certifications employers ask for
          </span>
        </div>

        {/* Wordmark grid — 6 chips, equal weight, hover lifts text into colour */}
        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 items-stretch gap-3 sm:gap-4">
          {PARTNERS.map((p) => (
            <li key={p.label}>
              <Link
                to={p.href}
                data-testid={`academy-partner-${p.label.toLowerCase().replace(/\s+/g, '-')}`}
                className="group block h-full rounded-xl border border-[#E5E5E7] bg-white px-3 py-3 text-center transition-all duration-300 hover:border-[#c9a227] hover:bg-[#fff8e7] hover:shadow-[0_8px_20px_-12px_rgba(201,162,39,0.45)]"
              >
                <div
                  className={`text-[18px] sm:text-[19px] font-extrabold tracking-tight text-[#9aa0a6] group-hover:text-[#0e0e10] transition-colors leading-none
                    ${p.mono ? 'lowercase' : ''}`}
                >
                  {p.label}
                </div>
                <div className="mt-1.5 text-[10.5px] uppercase tracking-[0.18em] text-[#9aa0a6] group-hover:text-[#a8871a] transition-colors font-semibold">
                  {p.sub}
                </div>
              </Link>
            </li>
          ))}
        </ul>

        <p className="mt-6 text-center text-[11px] text-[#9aa0a6] max-w-[640px] mx-auto leading-relaxed">
          ZHELTA Academy curriculum prepares learners for these vendor certifications.
          Logos are property of their respective owners; ZHELTA is not affiliated unless explicitly stated.
        </p>
      </div>
    </section>
  );
}
